// extracted by mini-css-extract-plugin
export default {"main_div":"formModal_main_div__3eBRb","error_msg":"formModal_error_msg__+Z1b8"};